export enum ReportEnum {
  ComparisonBasket = 57,
  MarketSummary = 26,
  DealerAnnualPlan = 31,
  RegistrationByBrandAndSegment = 34,
  DirectSellingGoalAndBilling = 37,
  MarketAnalysisLocale = 38,
  MarketAnalysisByProduct = 39,
  MarketEvolution = 41,
  RegistrationSegmentRegion = 42,
  MarketBreakDown = 43,
  DirectSalesGoalAndRegistration = 59,
  DNCParameters = 64,
  AnnualSalesPerformance = 65,
  SegmentPerformanceDetailed = 66,
  NearestReports = 70,
  BusinessPlanApproval = 71,
  FordMarketShareBrand = 72,
  DNCCompetitorsAnalysis = 73,
  FordThroughput = 76,
  PowerBI = 77,
  PbiMarketDiagnosis = 78,
  PbiGreenfield = 79,
  PbiAfterSales = 80,
  PbiDealerProfile = 81,
  PbiMarketDiagnosisFiatDealerGroup = 82,
  PbiMarketDiagnosisFordDealerGroup = 83,
  PbiMarketDiagnosisStellantis = 84,
  PbiDashboardSalesReport = 85,
  PbiParticipationTrainingGM = 86,
  PbiConversionReport = 87,
  PbiDealerEvaluation = 88,
  PbiBasketComparison = 89,
  PbiDealerGroup = 90,
  PbiDncUnmetDemandSalesGapLatam = 94,
  PbiDashboardDrdProjection = 95,
  PbiGmDncS10Study = 96,
  PbiDealerNetworkingBalance = 97,
  PbiDncBacktestAnalysis = 98,
  PbiEvTechReport = 99,
  PbiMarketDiagnosisNew = 100,
  PbiVehicleFleetCirculation = 101,
  PbiRecallMonitor = 102,
  PbiNetworkSimulatorAfterSales = 103,
  DncReportPage = 104,
  PbiWtlAfterSales = 105,
  PbiSalesRegistrationEffectiveness = 106,
  PbiNetworkSimulatorAutoPage = 107,
  PbiPerfomanceTrackingPage = 108,
  PbiAreaSegmentationAnalysis = 109,
  PbiAnnualSalesPerformance = 110,
  RegistrationSegmentRegionIntern = 111,
  PbiSouthAmerica = 112,
  PbiMulticriteriaAnalysis = 113,
  PbiNewDncBacktestAnalysis = 114,
  PbiMarketPotential = 115,
  Pbi2wPartsIntelligence = 116,
  PbiAnnualSalesPerformanceExport = 117,
  PbiGroupMapping = 118
}
